/********************  START WEB API SLUG ************* */

// Prefix
const API = '/api';
const USERMANAGEMENT = API + '/user-management/';
const COLLEGEMANAGEMENT = API + '/college/';
const ROLEMANAGEMENT = API + '/role-management/';
const BOOKAPPOINTMENT = API + '/bo/appointment/';
const INOUT = API + '/in-out/';
const JOB = API + '/job/';
const LETTERS = API + '/letters/';
const MASTERPREFIX = API + '/bo/master/';
const SCRUTINY = API + '/scrutiny/';
const REPORTPREFIX = API + '/bo/reports/';
const FINANCIALPREFIX = API + '/bo/financial-reports/';
const ACCOUNTS = API + '/account/';
const FRONT = API + '/dynamic/';
const APPLICATION = API + '/applications/';
const CERTIFICATE = API + '/bo/certificates/';

//Athencation
export const LOGIN = API + '/admin/login';
export const OTPVERIFICATION = API + '/admin/verifyotp';

// change password
export const CHANGE_PASSWORD = '/change-password';

// Dashboard
export const DASHBOARD = API + '/dashboard';

//Verification List
export const VERIFICATION_LIST = APPLICATION + 'get-scrutiny-verification';

//Search by filr or Gno
export const SEARCH = API + '/dashboard/search';

// ***************** START USER MANAGEMENT ***************** //
export const USERLIST = USERMANAGEMENT + 'list-users';
export const CREATE_USER = USERMANAGEMENT + 'create-user';
export const DELETE_USER = USERMANAGEMENT + 'delete-user';
export const USERROLELIST = USERMANAGEMENT + 'list-roles';
// ***************** END USER MANAGEMENT ***************** //

// ***************** START ROLE MANAGEMENT ***************** //

// Roles
export const ROLE_LIST = ROLEMANAGEMENT + 'list-roles';
export const ADD_ROLE = ROLEMANAGEMENT + 'save-role-permissions';
export const UPDATE_ROLE = ROLEMANAGEMENT + 'update-role-data';
export const ROLE_DATA_BY_ID = ROLEMANAGEMENT + 'get-role-data-by-id';
export const UPDATE_USER_MENU = ROLEMANAGEMENT + 'update-user-menu-data';
export const USER_DATA_BY_ID = API + '/get-user-data';

// User History

export const USER_HISTORY = APPLICATION + 'user-history';

// ***************** END ROLE MANAGEMENT ***************** //

// ***************** START COLLEGE MANAGEMENT ***************** //
//for refresher course
export const COLLEGE_LIST = COLLEGEMANAGEMENT + 'college-list';
export const COLLEGE_REGISTER = COLLEGEMANAGEMENT + 'register';
export const COLLEGE_EDIT = COLLEGEMANAGEMENT + 'edit-college';
export const COLLEGE_DELETE = COLLEGEMANAGEMENT + 'delete-college';
export const COLLEGE_LOGIN_APPROVE = COLLEGEMANAGEMENT + 'college-login-approval';
//get all master colleges
export const GET_COLLEGES = COLLEGEMANAGEMENT + 'colleges';
// pci approval
export const GET_PCI_APPROVAL = COLLEGEMANAGEMENT + 'list-pci-college-approval';
export const PCI_APPROVAL_STATUS = COLLEGEMANAGEMENT + 'change-pci-college-approval-status';
export const PENDING_PCI_APPROVALS = COLLEGEMANAGEMENT + 'list-pci-college-approval-pending';

// admitted list
export const GET_ADMITTED_LIST = COLLEGEMANAGEMENT + 'college-admitted-list-master';
export const GET_ADMIT_DETAIL = COLLEGEMANAGEMENT + 'college-admitted-list';
export const PENDING_ADMITTED_LIST = COLLEGEMANAGEMENT + 'college-admitted-list-master-pending';
export const ADMITTED_APPROVE_STATUS = COLLEGEMANAGEMENT + 'admitted-list-change-status';

// passout list
export const GET_PASSOUT_LIST = COLLEGEMANAGEMENT + 'passout-list-master';
export const GET_PASSOUT_DETAIL = COLLEGEMANAGEMENT + 'passout-list';
export const PENDING_PASSOUT_LIST = COLLEGEMANAGEMENT + 'passout-list-master-pending';
export const PASSOUT_APPROVE_STATUS = COLLEGEMANAGEMENT + 'passout-list-change-status';

// ***************** END COLLEGE MANAGEMENT ***************** //

// ***************** START REFRESHER COURSE ***************** //

//online refresher course
export const ADD_UPDATE_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'add-update-refresher-course';
export const DELETE_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'delete-refresher-course';
export const GET_REFRESHER_COURSE_LIST = COLLEGEMANAGEMENT + 'refresher-course-list';
export const GET_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'refresher-course-by-id';
export const CHANGE_REFRESHER_COURSE_STATUS = COLLEGEMANAGEMENT + 'change-refresher-course-status';
export const GET_REFRESHER_COURSE_CANDIDATE_LIST = COLLEGEMANAGEMENT + 'booked-slots-list';
export const GET_REFRESHER_COURSE_CERTIFICATION_LIST = COLLEGEMANAGEMENT + 'refresher-course-certification';
export const CHANGE_REFRESHER_COURSE_CERTIFICATE_STATUS = COLLEGEMANAGEMENT + 'refresher-certy-change-status';

//offline refresher course
export const OFFLINE_ADD_UPDATE_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'add-update-offline-refresher-course';
export const OFFLINE_DELETE_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'delete-offline-refresher-course';
export const OFFLINE_GET_REFRESHER_COURSE_LIST = COLLEGEMANAGEMENT + 'refresher-offline-course-list';
export const OFFLINE_GET_REFRESHER_COURSE = COLLEGEMANAGEMENT + 'offline-refresher-course-by-id';
export const OFFLINE_CHANGE_REFRESHER_COURSE_STATUS = COLLEGEMANAGEMENT + 'change-refresher-course-status';
export const OFFLINE_GET_REFRESHER_COURSE_CANDIDATE_LIST = COLLEGEMANAGEMENT + 'offline-booked-slots-list';
export const OFFLINE_GET_REFRESHER_COURSE_CERTIFICATION_LIST = COLLEGEMANAGEMENT + 'refresher-course-certification';
export const OFFLINE_CHANGE_REFRESHER_COURSE_CERTIFICATE_STATUS = COLLEGEMANAGEMENT + 'offline-refresher-certy-change-status';

// ***************** END REFRESHER COURSE ***************** //

//***************** Application Route  *************//
export const UPLOADPROFILE = APPLICATION + 'profile-pic-upload';
export const UPLOADELIGIBLEIMG = APPLICATION + 'eligible-profile-pic-upload';
export const UPDATEELEGIBLE = APPLICATION + 'update-eligible-file-details';
export const UPDATE_FILEDETAIL = APPLICATION + 'update-file-details';
export const FILEDETAIL = APPLICATION + 'get-file-details';

/************  Front Website Slugs Start ************/

// Banner
export const GET_BANNER = FRONT + 'get-banner-image';
export const ADD_BANNER = FRONT + 'add-banner';
export const UPDATE_BANNER = FRONT + 'change-banner';

// Notice
export const GET_NOTICE = FRONT + 'get-all-notice';
export const ADD_NOTICE = FRONT + 'add-notice';
export const NOTICE_STATUS = FRONT + 'change-notice-status';
export const DELETE_NOTICE = FRONT + 'delete-notice';

// Notice
export const GET_LATEST_UPDATE = FRONT + 'get-all-latest-update';
export const ADD_LATEST_UPDATE = FRONT + 'add-latest-update';
export const LATEST_UPDATE_STATUS = FRONT + 'change-latest-update-status';
export const DELETE_LATEST_UPDATE = FRONT + 'delete-latest-update';

// Gallery
export const GET_GALLERY = FRONT + 'get-all-gallery';
export const ADD_GALLERY = FRONT + 'add-gallery-images';
export const GALLERY_STATUS = FRONT + 'change-image-status';
export const DELETE_GALLERY = FRONT + 'delete-gallery-images';

//Inquiry
export const GET_INQUIRY = FRONT + 'get-contact-us-data';

/************  Front Website Slugs End  ************/

/************  Applications Slugs Start  ************/

// Address Change
export const GET_ADDRESSCHANGELIST = APPLICATION + 'search-address-change-app';

// Eligible Application
export const GET_ELIGIBLELIST = APPLICATION + 'search-eligible-app';
export const GET_ELEGIBLE_DATA = APPLICATION + 'get-eligible-file-details';

//delete Applcation
export const DELETE_APPLICATION = APPLICATION + 'delete-registered-app';

//document
export const DOCUMENTLIST = APPLICATION + 'document-list';
export const VERIFYDOCUMENT = APPLICATION + 'verify-document';
export const UPLOADDOCUMENT = APPLICATION + 'upload-document';
export const DOWNLODZIP = APPLICATION + 'download-zip-link';
export const APPROVEFRSHALLAPP = APPLICATION + 'approve-fresh-all-application';
export const ELIGIBLEDOCUMENTLIST = APPLICATION + 'eligible-document-list';
export const VERIFYELIGIBLEDOCUMET = APPLICATION + 'verify-eligible-document';
export const ELIGIBLEZIP = APPLICATION + 'eligible-download-zip-link';
export const UPLOADELIGIBLEDOCUMENT = APPLICATION + 'upload-eligible-document';
export const SAVEELIGIBLE = APPLICATION + 'save-eligible';
export const SAVEELIGIBLEOTHER = APPLICATION + 'save-eligible-other';
export const GETELEGIBLEDATA = APPLICATION + 'get-eligible-file-details';
export const APPROVEOTHERAPP = APPLICATION + 'approve-other-application';
export const APPROVEGOODSTANDINGPP = APPLICATION + 'save-duplicate-certificate';
export const CHANGESTATUS = APPLICATION + 'other-status-application';
export const CHANGEOTHERAPPSTATUS = APPLICATION + 'change-other-status-application';

export const APPROVEADDRESSCHANGE = APPLICATION + 'approve-address-change';
export const CHECKDUPLICATE = APPLICATION + 'check-duplicate';

export const ELECTIONAPPLICATION = APPLICATION + 'change-election-status';

// Fresh/Other/Transfer Application
export const GET_APPLICATIONLIST = APPLICATION + 'search-applicant-app';

// Good Standing
export const GET_GOODSTANDINGLIST = APPLICATION + 'goodStandingCertificate';

// Other Applications
export const OTHER_APPLIST = APPLICATION + 'search-other-app';

// Re-Entry Application
export const GET_REENTRY_LIST = APPLICATION + 'search-reentry-app';

// Registration Cancellation Application
export const REGISTRATION_CANCELLATION_LIST = APPLICATION + 'all-hold-applicant';
export const PERMANENT_CANCELLED_LIST = APPLICATION + 'get-closed-apps';

// Degree Addition Application
export const DEGREEADDITION_LIST = APPLICATION + 'search-additionaldegree-app';

// Provisional to Original Application
export const PROTOORG_LIST = APPLICATION + 'pro-to-original-list';
export const PRO_TO_ORG_REJECT = APPLICATION + 'pro-to-original-reject';

// Search Users
export const SEARCH_USERS = APPLICATION + 'list-users';

// Penalty Status Update
export const PENALTY_UPDATE = APPLICATION + 'update-penalty-status';

// Penalty Status jan vishwas Update
export const PENALTY_UPDATE_JAN_VISHWAS = APPLICATION + 'update-penalty-under-jan-vishwas-status';

//Search Applications
export const SEARCH_APPLICATION = APPLICATION + 'search';

// All Application Master List
export const APP_HOSPITAL = APPLICATION + 'hospitals';
export const APP_COLLEGE = APPLICATION + 'colleges';
export const APP_BOARDS = APPLICATION + 'boards';
export const APP_STATES = APPLICATION + 'states';
export const APP_COUNCIL = APPLICATION + 'councils';

//Approval Master List
export const SINGLE_COLLEGE_APPROVAL = MASTERPREFIX + 'single-college-approval';
export const College_Approval = MASTERPREFIX + 'college-approval';
export const SINGLE_COLLEGE_APPROVAL_DELETE = MASTERPREFIX + 'single-college-approval-delete';

// delete-with-refund
export const DELETE_REFUND = APPLICATION + 'delete-with-refund';

export const DELETE_PRE_APPLICATION = APPLICATION + 'delete-prefresh-application';
/************  Applications Slugs End  ************/

/************  Certificates Slugs Start  ************/

// Provisional Certificate
export const PROVISIONAL_CERTIFICATE_LIST = CERTIFICATE + 'provisionalCertificateList';
export const GET_PROVISIONAL_CERTIFICATE = CERTIFICATE + 'provisionalCertificate';
export const SAVE_PROVISONAL_CERTIFICATE = CERTIFICATE + 'provisionalCertificate';
export const DOWNLOAD_PROVISIONAL_CERTIFICATE = CERTIFICATE + 'download-provisional-certificate';

// Original Certificate
export const ORIGINAL_CERTIFICATE_LIST = CERTIFICATE + 'originalCertificateList';
export const SAVE_ORIGINAL_CERTIFICATE = CERTIFICATE + 'originalCertificate';
export const DOWNLOAD_ORIGINAL_CERTIFICATE = CERTIFICATE + 'download-original-certificate';

export const REMAINING_OC_LIST = SCRUTINY + 'get-original-pending';

//Duplicate Certificate List
export const DUPLICATE_CERTIFICATE_LIST = CERTIFICATE + 'get-duplicate-certificate-list';
export const DUPLICATE_CERTIFICATE_CHANGE_STATUS = CERTIFICATE + 'change-duplicate-certificate-status';

// Degree Addition Certificate
export const GET_DEGREE_ADDITION_CERTIFICATE = CERTIFICATE + 'degreeAdditionCertificate';
export const DOWNLOAD_DEGREE_ADDITION_CERTIFICATE = CERTIFICATE + 'download-degree-additional-certificate';

// GoodStanding Certificate
export const GET_GOODSTANDING_CERTIFICATE = CERTIFICATE + 'goodStandingCertificate';
export const DOWNLOAD_GOODSTANDING_CERTIFICATE = CERTIFICATE + 'download-good-standing';

// Reg Number Date Update
export const UPDATE_REG_DATE = CERTIFICATE + 'updateRegDate';

/************  Certificates Slugs End  ************/

/************  Billing Slugs Starts  ************/

// Billing
export const GET_BILLING = ACCOUNTS + 'get-billing';

/************  Billing Slugs Ends  ************/

/************  Account Slugs Starts  ************/
//bank-entry
export const GETBANKENTRY = ACCOUNTS + 'get-bankentry';
export const DOWNLOADVOUCHER = ACCOUNTS + 'get-voucher';
export const GETACCOUNTS = ACCOUNTS + 'get-account';

export const SAVEBANKENTRY = ACCOUNTS + 'store-bankentry';

export const GETVOUCHERS = ACCOUNTS + 'get-allrefrance-number';

//cash-entry
export const GETCASHENTRY = ACCOUNTS + 'get-cashentry';
export const SAVECASHENTRY = ACCOUNTS + 'store-cashentry';

//jv-entry
export const GETJVENTRY = ACCOUNTS + 'get-jventry';
export const SAVEJVENTRY = ACCOUNTS + 'store-jventry';
export const DOWNLOADJVENTRY = ACCOUNTS + 'download-jventry-details';

//account-master
export const CREATEACCOUNT = ACCOUNTS + 'create-account';

//accountgroup-master
export const CREATEACCOUNTGROUP = ACCOUNTS + 'store-account-group';
export const GETACCOUNTGROUP = ACCOUNTS + 'get-account-group';
export const DELETEACCOUNTGROUP = ACCOUNTS + 'account-group';

/************  Account Slugs End  ************/

/************ Master Slugs Start  ************/

//document master
export const DOCUMENTS = MASTERPREFIX + 'documents';
export const UPDATE_DOCUMENTS = MASTERPREFIX + 'update-documents';
export const DOCUMENT_MASTER = MASTERPREFIX + 'documents-master';
export const MAP_DOCUMENTS = MASTERPREFIX + 'map-documents';
export const EDIT_MAP_DOCUMENTS = MASTERPREFIX + 'edit-map-documents';

//Application Bill Master / BillModule
export const BILL_ITEM = MASTERPREFIX + 'bill-item';
export const BILL_MASTER = MASTERPREFIX + 'bill-master';

//Application Module
export const APPLICATIONS = MASTERPREFIX + 'applications';
export const UPDATE_APPLICATIONS = MASTERPREFIX + 'update-applications';

//Colleges Module
export const COLLEGES = MASTERPREFIX + 'colleges';
export const UPDATE_COLLEGES = MASTERPREFIX + 'update-colleges';
export const GET_COLLEGE_BY_ID = MASTERPREFIX + 'single-colleges';

//Board Module
export const BOARDS = MASTERPREFIX + 'boards';
export const UPDATE_BOARDS = MASTERPREFIX + 'update-boards';

//Council Module
export const COUNCIL = MASTERPREFIX + 'councils';
export const UPDATE_COUNCIL = MASTERPREFIX + 'update-councils';

//Exam Authority Module
export const EXAM_UTHORITY = MASTERPREFIX + 'exam-authority';
export const UPDATE_EXAM_UTHORITY = MASTERPREFIX + 'update-exam-authority';

//Hospital Module
export const HOSPITAL = MASTERPREFIX + 'hospitals';
export const UPDATE_HOSPITAL = MASTERPREFIX + 'update-hospitals';

//Other Master Module
export const OTHERMASTER = MASTERPREFIX + 'banks';
export const UPDATE_OTHERMASTER = MASTERPREFIX + 'update-banks';

//University Module
export const UNIVERSITY = MASTERPREFIX + 'university';
export const UPDATE_UNIVERSITY = MASTERPREFIX + 'update-university';

// User Update Module
export const MASTERUSERLIST = MASTERPREFIX + 'users-list';
export const LINKWITHGNO = MASTERPREFIX + 'linkwith-gno';
export const USERCHANGEEMAIL = MASTERPREFIX + 'user-change-email';
export const USERCHANGEPASSWORD = MASTERPREFIX + 'user-change-password';
export const GNOUSERDETAILS = MASTERPREFIX + 'gno-wise-details';
export const REGENERATE_SMART_CARD = MASTERPREFIX + 'download-smart-card';

export const UPDATE_PROFILE_PIC = MASTERPREFIX + 'profile-pic-upload';

/************  Master Slugs Ends  ************/

/************  Letters Slugs Start  ************/

//Letters
export const NOCLETTER = LETTERS + 'get-noc-letters';
export const STORENOCLETTER = LETTERS + 'storenoc-letter';
export const RUHSLETTER = LETTERS + 'get-ruhs-letter';
export const STORERUHSLETTER = LETTERS + 'store-ruhs-letter';
export const NIOSLETTER = LETTERS + 'get-nios-letter';
export const STORENIOSLETTER = LETTERS + 'store-nios-letter';
export const VERIFICATION = LETTERS + 'get-verification-letter';
export const STOREVERIFICATION = LETTERS + 'store-verification-letter';
export const REMINDERLETTER = LETTERS + 'get-reminder-letter';
export const STOREREMINDER = LETTERS + 'store-reminder-Letter';
export const CANCELLATIONLETTER = LETTERS + 'get-cancellation-letter';
export const STORECANCELLATIONLETTER = LETTERS + 'store-cancellation-letter';
export const TRANSFERLETTER = LETTERS + 'get-transfer-letter';
export const STORETRANSFERLETTER = LETTERS + 'store-transfer-letter';
export const TRAININGLETTER = LETTERS + 'get-training-letter';
export const STORETRAININGLETTER = LETTERS + 'store-training-letter';

export const GETDATAFLOWLETTER = LETTERS + 'get-dataflow-letter';
export const STOREDATAFLOWLETTER = LETTERS + 'store-dataflow-letter';

// Letters Masters List
export const LETTERSMASTERHOSPITALLIST = LETTERS + 'hospitals';
export const LETTERMASTERCOLLEGELIST = LETTERS + 'colleges';
export const LETTERMASTERBOARDSLIST = LETTERS + 'boards';
export const LETTERMASTERCOUNCILLIST = LETTERS + 'councils';
export const LETTERMASTERUNIVERSITYLIST = LETTERS + 'university';

//Download Letters
export const DOWNLOADNOCLETTER = LETTERS + 'download-noc-letter';
export const DOWNLOADRUHSLETTER = LETTERS + 'download-ruhs-letter';
export const DOWNLOADNIOSLETTER = LETTERS + 'download-nios-letter';
export const DOWNLOADVERIFICATIONLETTER = LETTERS + 'download-verification-letter';
export const DOWNLOADREMINDERLETTER = LETTERS + 'download-reminder-letter';
export const DOWNLOADCANCELLATIONLETTER = LETTERS + 'download-cancellation-letter';
export const DOWNLOADTRANSFERLETTER = LETTERS + 'download-transfer-letter';
export const DOWNLOADTRAININGLETTER = LETTERS + 'download-training-letter';

export const DOWNLOADDATAFLOWLETTER = LETTERS + 'download-dataflow-letter';

/************  Letters Slugs End  ************/

//States Modules
export const STATES = MASTERPREFIX + 'states';

/************  Inward and Outward Slugs Starts  ************/

export const GLOBALVAL = INOUT + 'get-globalval';

// Inward
export const GET_INWARD_LIST = INOUT + 'get-inward';
export const ADD_INWARD = INOUT + 'store-inward';

// Outward
export const GET_OUTWARD_LIST = INOUT + 'get-outward';
export const ADD_OUTWARD = INOUT + 'store-outward';

// In-Out
export const DELETE_IN_OUT = INOUT + 'deleteInOut';

/************  Inward and Outward Slugs Ends  ************/

// ***************** Job Portal Slugs Starts ***************** //

export const DEPARTMENT_LIST = JOB + 'departmentlist';
export const ADD_DEPARTMENT = JOB + 'adddedepartment';
export const UPDATE_DEPARTMENT = JOB + 'editdepartment';
export const JOB_LIST = JOB + 'companyjoblist';
export const UPDATE_JOB_STATUS = JOB + 'updatestatusjob';
export const UPDATE_STUDENT_STATUS = JOB + 'updatestudentstatus';
export const STUDENT_LIST = JOB + 'studentlist';
export const DELETE_STUDENT = JOB + 'deleteStudent';
export const DELETE_JOB = JOB + 'deleteJob';

export const DOWNLOAD_JOB_LIST = JOB + 'download-job-list';

//csv
export const EXPORT_JOB_CSV_LIST = JOB + 'export-job-list';

// ***************** Job Portal Slugs End ***************** //

// ***************** START REPORTS ***************** //
//Reports Module
export const APPLICATIONREGISTERREPORT = REPORTPREFIX + 'applicationRegister';
export const FEEREGISTERREPORT = REPORTPREFIX + 'feeRegister';
export const FRESHAPPLICATIONREGISTERREPORT = REPORTPREFIX + 'freshApplicationRecord';
export const DEGREEDETAILSREPORT = REPORTPREFIX + 'degreeDetails';
export const REGVALIDATIONREPORT = REPORTPREFIX + 'registrationValidation';
export const STATISTICSVALIDATIONREPORT = REPORTPREFIX + 'statisticsValidation';
export const INWARDOUTWARDREPORT = REPORTPREFIX + 'inOut-Register';
export const PROVISIONALORIGINALREPORT = REPORTPREFIX + 'provisional-original-certificate';
export const APPLICATIONDETAILSREPORT = REPORTPREFIX + 'applicationDetails';

export const GNUMBERWISEDETAILSREPORT = REPORTPREFIX + 'get-user-details-by-regnolist';
export const DOWNLOAD_GNUMBERWISE_LIST = REPORTPREFIX + 'export-user-details-by-regnolist';

export const GET_RECEIPT_LIST = REPORTPREFIX + 'get-receipt-certy-list';

export const COLLEGEWISEREG = REPORTPREFIX + 'collegeWiseReg';
export const GOVERNMENTREP = REPORTPREFIX + 'govReport';
export const DDREPORT = REPORTPREFIX + 'ddReport';
export const REGISTRATIONCACELLATION = REPORTPREFIX + 'registrationCancellation';
export const SUBTYPE = REPORTPREFIX + 'get-globalval';

// Report Master List
export const REPORTCOLLEGE = REPORTPREFIX + 'colleges';
export const REPORTBILLMASTER = REPORTPREFIX + 'bill-master';

// Electoral Election and Nomination Reports
export const DOWNLOADELECTORALAPPLICATIONREPORT = APPLICATION + 'download-electrol-application-report';

//Download Report

export const DOWNLOADAPPLICATIONREGITERREPORT = REPORTPREFIX + 'download-application-register';
export const DOWNLOADDEGREEDETAILS = REPORTPREFIX + 'download-degree-details';
export const DOWNLOADREGISTRATIONVALIDATION = REPORTPREFIX + 'download-registration-validation';
export const DOWNLOADAPPLICATIONDETAIL = REPORTPREFIX + 'download-application-details';
export const DOWNLOADINOUTREGISTER = REPORTPREFIX + 'download-inout-register';
export const DOWNLOADDDREPORT = REPORTPREFIX + 'download-dd-report';
export const DOWNLOADFEEREGISTER = REPORTPREFIX + 'download-fee-register';
export const DOWNLOADFRESHAPPLICATIONRECORD = REPORTPREFIX + 'download-fresh-application-record';
export const DOWNLOADPROVIORIREPORT = REPORTPREFIX + 'download-provisional-original-certificate';
export const DOWNLOADCOLLEGEWISEREGISTRATION = REPORTPREFIX + 'download-collegewise-registration';
export const DOWNLOADGOVENMENTREPORT = REPORTPREFIX + 'download-government';
export const DOWNLOADREGISTRATIONCANCELLATION = REPORTPREFIX + 'download-registration-cancellation';

// Download CSV
export const DOWNLOADPCIREGISTER = REPORTPREFIX + 'pci-register-csv';
export const DOWNLOADRECORDREGISTER = REPORTPREFIX + 'record-register-csv';

// ***************** END REPORTS ***************** //

// ***************** Start Scrutiny Slugs ***************** //
export const SEARCHSCRUTINY = SCRUTINY + 'get-scrutiny-data';
export const SEARCHAPPLICATIONS = SCRUTINY + 'get-file-details';
export const SEARCHAPPLICATIONSREENTRY = SCRUTINY + 'get-file-details-reentry';
export const SEARCHAPPLICATIONSDEGREEADD = SCRUTINY + 'get-file-details-degreeadd';
export const REENTRYSCRUTINYLIST = SCRUTINY + 'get-scrutiny-reentry-list';
export const SAVESCRUTINY = SCRUTINY + 'save-scrutiny-data';
export const SCRUTINYLIST = SCRUTINY + 'get-scrutiny-application-list';
export const SCRUTINYAPPDETAIL = SCRUTINY + 'get-file-details-by-fileno';
export const SCRUTINYDOCUMENTLIST = SCRUTINY + 'document-list';
export const SCRUTINYDOWNLODZIP = SCRUTINY + 'download-zip-link';
export const SCRUTINYBYRNO = SCRUTINY + 'get-scrutiny-data-by-rno';
export const SAVEREENTRYSCRUTINY = SCRUTINY + 'save-reentry-scrutiny-data';
export const SCRUTINYAPPTRANSFER = SCRUTINY + 'scrutiny-app-transfer';
export const DEGREEADDITIONSCRUTINYLIST = SCRUTINY + 'get-scrutiny-degreeadd-list';
export const SAVEDEGREEADDITIONSCRUTINY = SCRUTINY + 'save-scrutiny-degreeadd-data';

export const SCRUTINY_VERIFICATION = SCRUTINY + 'send-scrutiny-verification';
export const SCRUTINY_VERIFICATION_LIST = SCRUTINY + 'get-scrutiny-verification';
export const SCRUTINY_VERIFICATION_UPDATE = SCRUTINY + 'update-scrutiny-verification';
export const SCRUTINY_VERIFICATION_STAGE = SCRUTINY + 'add-scrutiny-verification';
export const SCRUTINY_HOLD = SCRUTINY + 'set-scrutiny-hold';
// ***************** End Scrutiny Slugs ***************** //

// **************** Start Financial Reports **************** //
//financial Report
export const ACCOUNTNAMES = FINANCIALPREFIX + 'accountnames';
export const ACCOUNTLEDGER = FINANCIALPREFIX + 'accountLedger';
export const CASHBOOKDETAIL = FINANCIALPREFIX + 'cashBookDetail';
export const BANKBOOKDETAIL = FINANCIALPREFIX + 'bankBookDetail';
export const JVBOOKDETAIL = FINANCIALPREFIX + 'jvBookDetail';
export const TRIALBALANCE = FINANCIALPREFIX + 'trialBalance';
export const PROFITLOSS = FINANCIALPREFIX + 'profitLoss';

// Financial Report Master
export const FINANCIALREPORTBILLMASTER = FINANCIALPREFIX + 'bill-master';

//download financial report
export const DOWNLOADACCOUNTLEDGER = FINANCIALPREFIX + 'download-account-ledger';
export const DOWNLOADCASHBOOK = FINANCIALPREFIX + 'download-cashbook-details';
export const DOWNLOADBANKBOOKDETAIL = FINANCIALPREFIX + 'download-bankbook-details';
export const DOWNLOADJVBBOKDETAIL = FINANCIALPREFIX + 'download-jvbook-details';

// **************** End Financial Reports **************** //

// ***************** Start Appointment Slugs ***************** //
export const APPOINTMENT = BOOKAPPOINTMENT + 'appointment';
export const BOOK_APPOINTMENT_SLOT = BOOKAPPOINTMENT + 'add-new-slot';
export const UPDATE_APPOINTMENT_SLOT = BOOKAPPOINTMENT + 'update-slot';
export const APPOINTMENTLIST = BOOKAPPOINTMENT + 'datewise-appointment-list';
export const DOWNLOAD_APPOINTMENT_LIST = BOOKAPPOINTMENT + 'download-slot-details ';
export const USER_APPOINTMENTLIST = BOOKAPPOINTMENT + 'get-slot-details';

export const GRAPH_APPOINTMENTLIST = BOOKAPPOINTMENT + 'datewise-appointment-graph';

// ***************** End Appointment Slugs ***************** //

export const HOLDUNHOLDAPPLICATION = APPLICATION + 'hold-unhold-applicant';
export const GETHOLDDATA = APPLICATION + 'get-user-details-by-regno-fileno';

export const CHANGE_HOLD_UNHOLD_APPLICANT = APPLICATION + 'change-hold-unhold-applicant';

// Get all booked appointment
export const BOOKED_APPOINTMENTLIST = BOOKAPPOINTMENT + 'get-all-slot-details';

// Get Generated Certificate Detail
export const GET_GENERATED_CERTIFICATE_DETAIL = COLLEGEMANAGEMENT + 'get-refresher-member-certificate-list';
export const GET_OFFLINE_GENERATED_CERTIFICATE_DETAIL = COLLEGEMANAGEMENT + 'get-offlinerefresher-member-certificate-list';
